const AppConfig = {
    backendUrl: process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL + '/' : 'http://localhost:8080/',
    pushLocalUrl: process.env.REACT_APP_PUSH_LOCAL_URL ? process.env.REACT_APP_PUSH_LOCAL_URL + '/' : 'http://localhost:8080/',
    filesHost: process.env.REACT_APP_FILES_HOST ? process.env.REACT_APP_FILES_HOST + '/' : 'http://127.0.0.1:8081/',
};

// Debug output
console.log('Environment Variables:', {
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    REACT_APP_PUSH_LOCAL_URL: process.env.REACT_APP_PUSH_LOCAL_URL,
    REACT_APP_FILES_HOST: process.env.REACT_APP_FILES_HOST
});

export default AppConfig;